// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__EUDQW.styles_ocean-50__mjOVk {
  color: #e6f2ff;
}

.styles_color__EUDQW.styles_ocean-100__HkP\\+D {
  color: #e6f2ff;
}

.styles_color__EUDQW.styles_ocean-200__6YCaK {
  color: #b3daff;
}

.styles_color__EUDQW.styles_ocean-300__ZC9Sd {
  color: #7abfff;
}

.styles_color__EUDQW.styles_ocean-400__uvzMg {
  color: #2392fb;
}

.styles_color__EUDQW.styles_ocean-500__IjC1Y {
  color: #0074e0;
}

.styles_color__EUDQW.styles_ocean-600__KLREX {
  color: #043571;
}

.styles_color__EUDQW.styles_space-50__OlKbt {
  color: #f0f0f0;
}

.styles_color__EUDQW.styles_space-100__E5Al8 {
  color: #e3e3e3;
}

.styles_color__EUDQW.styles_space-200__nUEil {
  color: #bfbfbf;
}

.styles_color__EUDQW.styles_space-300__34zg\\+ {
  color: gray;
}

.styles_color__EUDQW.styles_space-400__OP\\+EX {
  color: #616161;
}

.styles_color__EUDQW.styles_space-500__siFgF {
  color: #283439;
}

.styles_color__EUDQW.styles_gray-50__de7j1 {
  color: #eff3f6;
}

.styles_color__EUDQW.styles_gray-100__TgF0W {
  color: #e6ecef;
}

.styles_color__EUDQW.styles_gray-200__TKzZG {
  color: #cfd8de;
}

.styles_color__EUDQW.styles_gray-300__Rpx2b {
  color: #a8b9c2;
}

.styles_color__EUDQW.styles_gray-400__h9ld8 {
  color: #7e98a5;
}

.styles_color__EUDQW.styles_gray-500__\\+69qE {
  color: #738f9c;
}

.styles_color__EUDQW.styles_green-50__vvkL1 {
  color: #e3fdf6;
}

.styles_color__EUDQW.styles_green-100__GXzvv {
  color: #c5f6ea;
}

.styles_color__EUDQW.styles_green-200__3v1rx {
  color: #69ddc2;
}

.styles_color__EUDQW.styles_green-300__Prm1z {
  color: #45bfa3;
}

.styles_color__EUDQW.styles_green-400__jyxM8 {
  color: #1cab8a;
}

.styles_color__EUDQW.styles_green-500__-ZnvF {
  color: #128268;
}

.styles_color__EUDQW.styles_red-50__E6wHq {
  color: #fff0f3;
}

.styles_color__EUDQW.styles_red-100__vJ1\\+N {
  color: #f9d2db;
}

.styles_color__EUDQW.styles_red-200__wDFdf {
  color: #f8b4c4;
}

.styles_color__EUDQW.styles_red-300__REJjm {
  color: #e85e81;
}

.styles_color__EUDQW.styles_red-400__p1NxK {
  color: #e23661;
}

.styles_color__EUDQW.styles_red-500__xyOCx {
  color: #b82348;
}

.styles_color__EUDQW.styles_yellow-50__zy0Kb {
  color: #fffae6;
}

.styles_color__EUDQW.styles_yellow-100__vxBUr {
  color: #fff0b3;
}

.styles_color__EUDQW.styles_yellow-200__02uG4 {
  color: #ffe380;
}

.styles_color__EUDQW.styles_yellow-300__M\\+BMX {
  color: #ffcf57;
}

.styles_color__EUDQW.styles_yellow-400__zdrlm {
  color: #ffc60a;
}

.styles_color__EUDQW.styles_yellow-500__WVYfT {
  color: #ffb700;
}

.styles_color__EUDQW.styles_orange-50__6QehP {
  color: #fff2eb;
}

.styles_color__EUDQW.styles_orange-100__U6AL7 {
  color: #ffe4d6;
}

.styles_color__EUDQW.styles_orange-200__IKlqh {
  color: #ffc69e;
}

.styles_color__EUDQW.styles_orange-300__cb3eO {
  color: #ffa047;
}

.styles_color__EUDQW.styles_orange-400__96ZX1 {
  color: #ff7b42;
}

.styles_color__EUDQW.styles_orange-500__Ue0l7 {
  color: #ee4920;
}

.styles_color__EUDQW.styles_turquoise-50__1ahfa {
  color: transparent;
}

.styles_color__EUDQW.styles_turquoise-100__e\\+Lst {
  color: #e6fcff;
}

.styles_color__EUDQW.styles_turquoise-200__IraVp {
  color: #b3f5ff;
}

.styles_color__EUDQW.styles_turquoise-300__ehDO2 {
  color: #78e2f2;
}

.styles_color__EUDQW.styles_turquoise-400__BHnrF {
  color: #00c7e6;
}

.styles_color__EUDQW.styles_turquoise-500__UPRL6 {
  color: transparent;
}

.styles_color__EUDQW.styles_turquoise-600__BEzu8 {
  color: transparent;
}

.styles_color__EUDQW.styles_violet-50__LJHn- {
  color: #eae6ff;
}

.styles_color__EUDQW.styles_violet-100__WK\\+7f {
  color: #d9d1ff;
}

.styles_color__EUDQW.styles_violet-200__rQGsK {
  color: #bfb3ff;
}

.styles_color__EUDQW.styles_violet-300__LkGg5 {
  color: #9d90ea;
}

.styles_color__EUDQW.styles_violet-400__pvIfz {
  color: #8678d9;
}

.styles_color__EUDQW.styles_violet-500__-2C4m {
  color: #6f5ccc;
}

.styles_color__EUDQW.styles_snow-50__HvM9J {
  color: white;
}

.styles_color__EUDQW.styles_snow-100__PJ6NR {
  color: #f7f7f7;
}

.styles_color__EUDQW.styles_snow-200__JnnuN {
  color: #f0efef;
}

.styles_color__EUDQW.styles_snow-300__h0NaU {
  color: #e6e6e6;
}

.styles_color__EUDQW.styles_snow-400__RxMIF {
  color: #e1e0e0;
}

.styles_color__EUDQW.styles_snow-500__UGvaa {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__9YkSf.styles_ocean__8ioCx {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__9YkSf.styles_ocean-light__ZOrdl {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__9YkSf.styles_green__2y5ez {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__9YkSf.styles_green-light__p3ysX {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__9YkSf.styles_red__r4rl0 {
  background-color: #e23661;
  color: white;
}

.styles_background-color__9YkSf.styles_red-light__dNNWY {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__9YkSf.styles_orange__seQzx {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__9YkSf.styles_orange-light__Cfq5X {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__9YkSf.styles_space__6zalH {
  background-color: #616161;
  color: white;
}

.styles_background-color__9YkSf.styles_space-light__AgZJs {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__9YkSf.styles_gray-light__5eFbg {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__9YkSf.styles_violet__125y6 {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__9YkSf.styles_violet-light__DtbYu {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__9YkSf.styles_yellow__iUmFL {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__9YkSf.styles_yellow-light__dZXFN {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_overlay__cpd0w {
  background-color: rgba(40, 52, 57, 0.6);
  inset: 0;
  position: fixed;
  z-index: 1200;
}
.styles_overlay__cpd0w.styles_overPopover__VH-lV {
  z-index: 10000;
}
.styles_overlay__cpd0w .styles_overlay__cpd0w {
  border-radius: calc(12px - 0.5px);
}

.styles_content__n-BxC {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 18px 28px rgba(9, 30, 66, 0.15), 0 0 1px rgba(9, 30, 66, 0.31);
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  left: 50%;
  max-height: 600px;
  min-width: 400px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 100px);
  z-index: 1201;
}
.styles_content__n-BxC.styles_fullWidth__4XhiA {
  width: calc(100% - 40px);
}
.styles_content__n-BxC.styles_fullHeight__YVEYd {
  height: calc(100% - 80px);
}
.styles_content__n-BxC.styles_fullScreen__HaCxx {
  border-radius: 0;
  height: 100%;
  max-height: 100%;
  max-width: none !important;
  width: 100%;
}
.styles_content__n-BxC.styles_xs__L4yQh {
  width: 400px;
}
.styles_content__n-BxC.styles_sm__8-DFa {
  width: 600px;
}
.styles_content__n-BxC.styles_md__\\+w-a1 {
  width: 752px;
}
.styles_content__n-BxC.styles_lg__Jp4oK {
  width: 968px;
}
.styles_content__n-BxC.styles_xl__35uz4 {
  width: 1140px;
}
.styles_content__n-BxC.styles_xxl__9oZFz {
  max-width: 1480px;
}
.styles_content__n-BxC .styles_headerWrapper__siiv2 {
  border-bottom: 2px solid #eff3f6;
  padding: 24px ;
  padding-bottom: 16px ;
}
.styles_content__n-BxC .styles_titleWrapper__JtEHZ {
  overflow: hidden;
  width: calc(100% - 24px);
}
.styles_content__n-BxC .styles_titleWrapper__JtEHZ .styles_iconWrapper__T\\+RT0 {
  margin-right: 8px ;
  margin-top: 2px;
}
.styles_content__n-BxC .styles_titleWrapper__JtEHZ .styles_titleText__DCKqF {
  font-weight: 500;
  font-size: 1.4285714286rem;
  letter-spacing: -0.33px;
  line-height: 30px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  color: #283439;
  margin: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.styles_content__n-BxC .styles_bodyWrapper__cYgHj {
  height: 100%;
  overflow: auto;
  padding: 24px ;
}
.styles_content__n-BxC .styles_footerWrapper__Eymi8 {
  border-top: 2px solid #eff3f6;
  padding: 16px 24px 16px 16px ;
}
.styles_content__n-BxC.styles_overPopover__VH-lV {
  z-index: 10001;
}
.styles_content__n-BxC .styles_button__\\+F4tM {
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  border-radius: 3px;
  color: white;
  min-width: 73px;
  padding: 8px 12px ;
  text-align: center;
}
.styles_content__n-BxC .styles_button__\\+F4tM.styles_disabled__d0UKX {
  opacity: 0.5;
}
.styles_content__n-BxC .styles_button__\\+F4tM.styles_cancelButton__4hmTL {
  background-color: #f7f7f7;
  color: #616161;
  margin-left: 16px ;
}
.styles_content__n-BxC .styles_button__\\+F4tM.styles_error__h69Wc {
  background-color: #b82348;
}
.styles_content__n-BxC .styles_button__\\+F4tM.styles_warning__e-33i {
  background-color: #ffc60a;
}
.styles_content__n-BxC .styles_button__\\+F4tM.styles_info__TwAsR {
  background-color: #0074e0;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/dialog/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,uCAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;AA0UJ;AAxUI;EACI,cAAA;AA0UR;AAvUI;EAEI,iCAAA;AAwUR;;AApUA;EACI,uBAAA;EACA,mBAAA;EACA,4EAAA;EACA,aAAA;EACA,wBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;EACA,gCAAA;EACA,yBAAA;EACA,aAAA;AAuUJ;AArUI;EACI,wBAAA;AAuUR;AApUI;EACI,yBAAA;AAsUR;AAnUI;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;AAqUR;AAlUI;EACI,YAAA;AAoUR;AAjUI;EACI,YAAA;AAmUR;AAhUI;EACI,YAAA;AAkUR;AA/TI;EACI,YAAA;AAiUR;AA9TI;EACI,aAAA;AAgUR;AA7TI;EACI,iBAAA;AA+TR;AA5TI;EACI,gCAAA;EACA,cAAA;EACA,qBAAA;AA8TR;AA3TI;EACI,gBAAA;EACA,wBAAA;AA6TR;AA3TQ;EACI,kBAAA;EACA,eAAA;AA6TZ;AA1TQ;EErCJ,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFuFb,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AA+TZ;AA3TI;EACI,YAAA;EACA,cAAA;EACA,cAAA;AA6TR;AA1TI;EACI,6BAAA;EACA,6BAAA;AA4TR;AAzTI;EACI,cAAA;AA2TR;AAvTI;EElEA,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFoHjB,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AA4TR;AA1TQ;EACI,YAAA;AA4TZ;AAzTQ;EACI,yBAAA;EACA,cAAA;EACA,kBAAA;AA2TZ;AAxTQ;EACI,yBAAA;AA0TZ;AAvTQ;EACI,yBAAA;AAyTZ;AAtTQ;EACI,yBAAA;AAwTZ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.overlay {\n    background-color: rgba(theme.color(space-500), 0.6);\n    inset: 0;\n    position: fixed;\n    z-index: theme.get-z-index(dialog-overlay);\n\n    &.overPopover {\n        z-index: theme.get-z-index(dialog-over-data-radix-popper-content-wrapper-overlay);\n    }\n\n    .overlay {\n        // 12px equals the theme.get-border-radius(xl) value\n        border-radius: calc(12px - 0.5px);\n    }\n}\n\n.content {\n    background-color: theme.color(snow-50);\n    border-radius: theme.get-border-radius(xl);\n    box-shadow: theme.box-shadow(xl);\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: space-between;\n    left: 50%;\n    max-height: 600px;\n    min-width: 400px;\n    position: fixed;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: calc(100% - 100px);\n    z-index: theme.get-z-index(dialog-content);\n\n    &.fullWidth {\n        width: calc(100% - 40px);\n    }\n\n    &.fullHeight {\n        height: calc(100% - 80px);\n    }\n\n    &.fullScreen {\n        border-radius: 0;\n        height: 100%;\n        max-height: 100%;\n        max-width: none !important;\n        width: 100%;\n    }\n\n    &.xs {\n        width: 400px;\n    }\n\n    &.sm {\n        width: 600px;\n    }\n\n    &.md {\n        width: 752px;\n    }\n\n    &.lg {\n        width: 968px;\n    }\n\n    &.xl {\n        width: 1140px;\n    }\n\n    &.xxl {\n        max-width: 1480px;\n    }\n\n    .headerWrapper {\n        border-bottom: 2px solid theme.color(gray-50);\n        padding: theme.spacing(3);\n        padding-bottom: theme.spacing(2);\n    }\n\n    .titleWrapper {\n        overflow: hidden;\n        width: calc(100% - 24px);\n\n        .iconWrapper {\n            margin-right: theme.spacing(1);\n            margin-top: 2px;\n        }\n\n        .titleText {\n            @include theme.typo(h2);\n\n            color: theme.color(space-500);\n            margin: 0;\n            overflow: hidden;\n            text-align: left;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            width: 100%;\n        }\n    }\n\n    .bodyWrapper {\n        height: 100%;\n        overflow: auto;\n        padding: theme.spacing(3);\n    }\n\n    .footerWrapper {\n        border-top: 2px solid theme.color(gray-50);\n        padding: theme.spacing(2, 3, 2, 2);\n    }\n\n    &.overPopover {\n        z-index: theme.get-z-index(dialog-over-data-radix-popper-content-wrapper-content);\n    }\n\n    // TODO-MAYBE: Do we need this?!\n    .button {\n        @include theme.typo(body2);\n\n        border-radius: theme.get-border-radius(sm);\n        color: theme.color(snow-50);\n        min-width: 73px;\n        padding: theme.spacing(1, 1.5);\n        text-align: center;\n\n        &.disabled {\n            opacity: 0.5;\n        }\n\n        &.cancelButton {\n            background-color: theme.color(snow-100);\n            color: theme.color(space-400);\n            margin-left: theme.spacing(2);\n        }\n\n        &.error {\n            background-color: theme.color(red-500);\n        }\n\n        &.warning {\n            background-color: theme.color(yellow-400);\n        }\n\n        &.info {\n            background-color: theme.color(ocean-500);\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__EUDQW`,
	"ocean-50": `styles_ocean-50__mjOVk`,
	"ocean-100": `styles_ocean-100__HkP+D`,
	"ocean-200": `styles_ocean-200__6YCaK`,
	"ocean-300": `styles_ocean-300__ZC9Sd`,
	"ocean-400": `styles_ocean-400__uvzMg`,
	"ocean-500": `styles_ocean-500__IjC1Y`,
	"ocean-600": `styles_ocean-600__KLREX`,
	"space-50": `styles_space-50__OlKbt`,
	"space-100": `styles_space-100__E5Al8`,
	"space-200": `styles_space-200__nUEil`,
	"space-300": `styles_space-300__34zg+`,
	"space-400": `styles_space-400__OP+EX`,
	"space-500": `styles_space-500__siFgF`,
	"gray-50": `styles_gray-50__de7j1`,
	"gray-100": `styles_gray-100__TgF0W`,
	"gray-200": `styles_gray-200__TKzZG`,
	"gray-300": `styles_gray-300__Rpx2b`,
	"gray-400": `styles_gray-400__h9ld8`,
	"gray-500": `styles_gray-500__+69qE`,
	"green-50": `styles_green-50__vvkL1`,
	"green-100": `styles_green-100__GXzvv`,
	"green-200": `styles_green-200__3v1rx`,
	"green-300": `styles_green-300__Prm1z`,
	"green-400": `styles_green-400__jyxM8`,
	"green-500": `styles_green-500__-ZnvF`,
	"red-50": `styles_red-50__E6wHq`,
	"red-100": `styles_red-100__vJ1+N`,
	"red-200": `styles_red-200__wDFdf`,
	"red-300": `styles_red-300__REJjm`,
	"red-400": `styles_red-400__p1NxK`,
	"red-500": `styles_red-500__xyOCx`,
	"yellow-50": `styles_yellow-50__zy0Kb`,
	"yellow-100": `styles_yellow-100__vxBUr`,
	"yellow-200": `styles_yellow-200__02uG4`,
	"yellow-300": `styles_yellow-300__M+BMX`,
	"yellow-400": `styles_yellow-400__zdrlm`,
	"yellow-500": `styles_yellow-500__WVYfT`,
	"orange-50": `styles_orange-50__6QehP`,
	"orange-100": `styles_orange-100__U6AL7`,
	"orange-200": `styles_orange-200__IKlqh`,
	"orange-300": `styles_orange-300__cb3eO`,
	"orange-400": `styles_orange-400__96ZX1`,
	"orange-500": `styles_orange-500__Ue0l7`,
	"turquoise-50": `styles_turquoise-50__1ahfa`,
	"turquoise-100": `styles_turquoise-100__e+Lst`,
	"turquoise-200": `styles_turquoise-200__IraVp`,
	"turquoise-300": `styles_turquoise-300__ehDO2`,
	"turquoise-400": `styles_turquoise-400__BHnrF`,
	"turquoise-500": `styles_turquoise-500__UPRL6`,
	"turquoise-600": `styles_turquoise-600__BEzu8`,
	"violet-50": `styles_violet-50__LJHn-`,
	"violet-100": `styles_violet-100__WK+7f`,
	"violet-200": `styles_violet-200__rQGsK`,
	"violet-300": `styles_violet-300__LkGg5`,
	"violet-400": `styles_violet-400__pvIfz`,
	"violet-500": `styles_violet-500__-2C4m`,
	"snow-50": `styles_snow-50__HvM9J`,
	"snow-100": `styles_snow-100__PJ6NR`,
	"snow-200": `styles_snow-200__JnnuN`,
	"snow-300": `styles_snow-300__h0NaU`,
	"snow-400": `styles_snow-400__RxMIF`,
	"snow-500": `styles_snow-500__UGvaa`,
	"background-color": `styles_background-color__9YkSf`,
	"ocean": `styles_ocean__8ioCx`,
	"ocean-light": `styles_ocean-light__ZOrdl`,
	"green": `styles_green__2y5ez`,
	"green-light": `styles_green-light__p3ysX`,
	"red": `styles_red__r4rl0`,
	"red-light": `styles_red-light__dNNWY`,
	"orange": `styles_orange__seQzx`,
	"orange-light": `styles_orange-light__Cfq5X`,
	"space": `styles_space__6zalH`,
	"space-light": `styles_space-light__AgZJs`,
	"gray-light": `styles_gray-light__5eFbg`,
	"violet": `styles_violet__125y6`,
	"violet-light": `styles_violet-light__DtbYu`,
	"yellow": `styles_yellow__iUmFL`,
	"yellow-light": `styles_yellow-light__dZXFN`,
	"overlay": `styles_overlay__cpd0w`,
	"overPopover": `styles_overPopover__VH-lV`,
	"content": `styles_content__n-BxC`,
	"fullWidth": `styles_fullWidth__4XhiA`,
	"fullHeight": `styles_fullHeight__YVEYd`,
	"fullScreen": `styles_fullScreen__HaCxx`,
	"xs": `styles_xs__L4yQh`,
	"sm": `styles_sm__8-DFa`,
	"md": `styles_md__+w-a1`,
	"lg": `styles_lg__Jp4oK`,
	"xl": `styles_xl__35uz4`,
	"xxl": `styles_xxl__9oZFz`,
	"headerWrapper": `styles_headerWrapper__siiv2`,
	"titleWrapper": `styles_titleWrapper__JtEHZ`,
	"iconWrapper": `styles_iconWrapper__T+RT0`,
	"titleText": `styles_titleText__DCKqF`,
	"bodyWrapper": `styles_bodyWrapper__cYgHj`,
	"footerWrapper": `styles_footerWrapper__Eymi8`,
	"button": `styles_button__+F4tM`,
	"disabled": `styles_disabled__d0UKX`,
	"cancelButton": `styles_cancelButton__4hmTL`,
	"error": `styles_error__h69Wc`,
	"warning": `styles_warning__e-33i`,
	"info": `styles_info__TwAsR`
};
export default ___CSS_LOADER_EXPORT___;
